export default __webpack_public_path__ + "static/restauration_cover_mobile-de23523b23e3d011e694bf69cc0b225d.jpg";